import Collapse from './components/Collapse';
import CollapsePlugin from './plugin/Collapse';
import Toggle from './directives/Toggle';

export { Collapse };

export { Toggle };

export default CollapsePlugin;
